export enum DirectiveQueryParam {
    'la', //leave admin
    'cd', //case details
}